import Vue from 'vue'
import App from './App.vue'
import dataV from '@jiaminghi/data-view'
import './styles/base.scss'
import Element from 'element-ui'
import './styles/element-variables.scss'
import http from '@/api/request.js'



Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.use(dataV)
Vue.use(Element, {
  size: 'mini'
})

new Vue({
  render: h => h(App),
}).$mount('#app')
